const currentYear = new Date().getFullYear();
export const birthYearOptions = [
  { value: null, label: "Prefer not to say" },
  ...Array.from({ length: 68 }, (_, i) => {
    const year = currentYear - 13 - i;
    return { value: year.toString(), label: year.toString() };
  }),
];